module.exports = __webpack_public_path__ + "img/Reward icon-02.eb366cc8.png";